import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { TranslateModule } from '@ngx-translate/core';
import { DragDropDirective } from '@shared/directives';
import { AngularIbanModule } from 'angular-iban';
import { QrCodeModule } from 'ng-qrcode';
import { WebcamModule } from 'ngx-webcam';
import { MaterialModule } from '../material/material.module';
import * as components from './components';
import { CustomDateAdapter } from './components/dynamic-form/CustomDateAdapter';
import { DynamicFormControlComponent } from './components/dynamic-form/dynamic-form-control/dynamic-form-control.component';
import { DynamicFormComponent } from './components/dynamic-form/dynamic-form.component';
import { E401Component } from './components/e401/e401.component';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        MaterialModule,
        TranslateModule,
        WebcamModule,
        AngularIbanModule,
        DragDropModule,
        QrCodeModule
    ],
    providers: [
        { provide: DateAdapter, useClass: CustomDateAdapter },
        { provide: MAT_DATE_LOCALE, useValue: 'nl-BE' },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    declarations: [
        ...components.entities,
        DynamicFormComponent,
        DynamicFormControlComponent,
        E401Component,
        DragDropDirective,
    ],
    exports: [
        ...components.entities,
        TranslateModule,
        DragDropDirective
    ],
    schemas: [
      CUSTOM_ELEMENTS_SCHEMA
    ]
})
export class SharedModule { }
